import React from 'react';
export function Footer() {
  return <footer className="bg-white text-gray-600 py-12 px-4 text-center border-t-4 border-pink-100" data-id="element-64">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-65">
        <img src="https://cdn.magicpatterns.com/uploads/mL8rDdL5N8A3Jazhiq4aMw/Copia_de_Logo_DECO_MAGIC.png" alt="Deco Magic Logo" className="h-20 mb-6" data-id="element-66" />

        <p className="mb-4 font-medium text-gray-500" data-id="element-67">
          © 2026 Magic Party Kit — Deco Magic · All rights reserved
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400" data-id="element-68">
          <span data-id="element-69">Contact: mundoinfantildigital10@gmail.com</span>
          <span className="hidden md:inline" data-id="element-70">·</span>
          <span data-id="element-71">Instagram: @decomagickit</span>
        </div>
      </div>
    </footer>;
}